import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { AppPageModifier } from "components/pages/app-page-modifier";
import { ExamClearer } from "components/pages/_exam/exam-clearer";

class ReloadExtendableExamPage extends Component {
    state = {};

    constructor(props) {
        super(props);
        const { match } = this.props;
        this.examGuid = match.params.examGuid;

        this.handleExamCleared = this.handleExamCleared.bind(this);
        this.handleMovePage = this.handleMovePage.bind(this);
    }

    handleExamCleared() {
        this.timer = setTimeout(this.handleMovePage, 5 * 10000);
    }

    handleMovePage() {
        const { history } = this.props;
        history.push(`/exam/${this.examGuid}`);
    }

    render() {
        const appBarProps = {
            title: "Extending Exam",
            loadingTitle: true,
            logo: true,
            logout: false,
        };

        return (
            <>
                <AppPageModifier
                    appBarProps={appBarProps}
                    loading
                />
                <ExamClearer onClear={this.handleExamCleared} />
            </>
        );
    }
}

ReloadExtendableExamPage = withRouter(ReloadExtendableExamPage);

export { ReloadExtendableExamPage };
